import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'unsafeDocument'
})
export class UnsafeDocumentPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value): unknown {
    console.log('value..',value)
    return this.sanitizer.bypassSecurityTrustResourceUrl(value + '#toolbar=0');
  }

}
